import { UnauthenticatedRoute } from 'components/Route';
import React from 'react';
import { Switch } from 'react-router';
import usePageTracking from 'utilities/usePageTracking';

// Pages
import Home from './Home/Home';
import Article from './Article/Article';

export default function Routes() {
	usePageTracking();

  return (
    <Switch>
      <UnauthenticatedRoute exact path="/:id?" component={Home} />
      <UnauthenticatedRoute exact path="/artikel/:id" component={Article} />
      <UnauthenticatedRoute exact path="/pagina/:url" component={Article} />
    </Switch>
  );
}
